import React from "react";

// Résumé-style row: section name in a left column on desktop, content on the right.
// Prose sections keep a readable measure; `wide` lets cards use the full column.
function Section({ id, label, wide = false, children }) {
  return (
    <section id={id} className="px-6">
      <div className="max-w-5xl mx-auto border-t border-line py-10 md:py-16 md:grid md:grid-cols-[176px_1fr] md:gap-12">
        <h2 className="flex items-center gap-3 font-mono text-[13px] font-medium uppercase tracking-[0.08em] text-dim mb-5 md:mb-0 md:pt-2 md:self-start before:content-[''] before:h-px before:w-5 before:bg-leaf">
          {label}
        </h2>
        <div className={`min-w-0 ${wide ? "" : "max-w-[65ch]"}`}>{children}</div>
      </div>
    </section>
  );
}

export default Section;
